var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconThematicGroups(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlSpace: "preserve",
    overflow: "hidden",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-109 -255)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M122.75 261.725C122.75 262.7 121.975 263.475 121 263.475 120.025 263.475 119.25 262.7 119.25 261.725 119.25 260.75 120.025 259.975 121 259.975 121.975 259.975 122.75 260.775 122.75 261.725",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.75 262.725C129.75 263.7 128.975 264.475 128 264.475 127.025 264.475 126.25 263.7 126.25 262.725 126.25 261.75 127.025 260.975 128 260.975 128.975 260.975 129.75 261.75 129.75 262.725",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.75 262.725C115.75 263.7 114.975 264.475 114 264.475 113.025 264.475 112.25 263.7 112.25 262.725 112.25 261.75 113.025 260.975 114 260.975 114.975 260.975 115.75 261.75 115.75 262.725",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.15 274.025C111.15 270.375 115.55 267.425 121 267.425 126.425 267.425 130.85 270.375 130.85 274.025L111.15 274.025Z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.4 268.35C114.45 267.65 115.675 267.1 117 266.75L117 266.475C117 266.2 116.875 265.925 116.7 265.75 116.625 265.675 116.45 265.575 116.225 265.475 114.85 264.825 113.225 264.825 111.825 265.45 111.575 265.55 111.375 265.675 111.275 265.75 111.125 265.925 111 266.2 111 266.475L111 270.725C111.575 269.85 112.375 269.025 113.4 268.35",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124 266.5 124 265.475C124 265.2 123.875 264.925 123.7 264.75 123.625 264.675 123.45 264.575 123.225 264.475 121.85 263.825 120.225 263.825 118.825 264.45 118.575 264.55 118.375 264.675 118.275 264.75 118.075 264.925 117.975 265.2 117.975 265.475L117.975 266.5C118.95 266.3 119.95 266.2 120.975 266.2 122 266.2 123.025 266.325 124 266.5",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131 270.725 131 266.475C131 266.2 130.875 265.925 130.7 265.75 130.625 265.675 130.45 265.575 130.225 265.475 128.85 264.825 127.225 264.825 125.825 265.45 125.575 265.55 125.375 265.675 125.275 265.75 125.075 265.925 124.975 266.2 124.975 266.475L124.975 266.75C126.3 267.1 127.525 267.65 128.575 268.35 129.625 269.025 130.425 269.85 131 270.725",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconThematicGroups);
export default __webpack_public_path__ + "static/media/icon-thematic-groups.af2065da988e4843a55ef4029314762e.svg";
export { ForwardRef as ReactComponent };